import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import DashboardLayout from '../../layouts/DashboardLayout';
import {
  fetchEssayExamPaperRequest,
  acceptEssayPaperReaquest,
  rejectEssayPaperRequest
} from '../../actions/CorrectorAction';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';

function CorrectorPaperRequest() {
  const dispatch = useDispatch();
  const history = useHistory();
  const essaypaperRequest = useSelector((state) => state.essayPaperRequest.essaypaperRequest);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const { t, i18n } = useTranslation();

  const language = useSelector((state) => state.language).selectedLanguage;

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  const handleClick = (click, id) => {
    if (click == 'accept') {
      dispatch(
        acceptEssayPaperReaquest(id, () => {
          history.push('/corrector-current-work');
        })
      );
    } else if (click == 'reject') {
      dispatch(
        rejectEssayPaperRequest(id, () => {
          history.push('/corrector-current-work');
        })
      );
    }
    setTriggerUpdate(!triggerUpdate);
  };
  useEffect(() => {
    dispatch(fetchEssayExamPaperRequest());
  }, [triggerUpdate]);
  const requestList = (request, index) => {
    return (
      <TableRow key={index}>
        <TableCell>{new Date().toDateString()}</TableCell>
        <TableCell>{request.subject}</TableCell>
        <TableCell>{request.title}</TableCell>
        <TableCell>{request.teacherName}</TableCell>
        <TableCell>
          <Button variant="contained" onClick={() => handleClick('accept', request.id)}>
            {t('accept')}
          </Button>
          <Button variant="contained" onClick={() => handleClick('reject', request.id)}>
            {t('reject')}
          </Button>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <DashboardLayout>
      <Card>
        <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <h2
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                {t('teacher_request_paper_correction')}
              </h2>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>{t('start_date')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('subject_name')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('subject_title')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('teacher')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('action')}</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {essaypaperRequest &&
                    essaypaperRequest.length >= 1 &&
                    essaypaperRequest.map((request, index) => requestList(request, index))}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default CorrectorPaperRequest;
